"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _richTextTypes = require("@contentful/rich-text-types");
var _RichTextHyperlink = _interopRequireDefault(require("./RichTextHyperlink"));
var _RichTextList = _interopRequireWildcard(require("./RichTextList"));
var _RichTextBold = _interopRequireDefault(require("./RichTextBold"));
var _RichTextHeading = _interopRequireDefault(require("./RichTextHeading"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _RichTextParagraph = _interopRequireDefault(require("./RichTextParagraph"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function headingComponentWrapper(heading, children, inverse, align) {
  return /*#__PURE__*/_react.default.createElement(_RichTextHeading.default, {
    inverse: inverse,
    heading: heading,
    align: align
  }, children);
}
var configOptions = _ref => {
  var {
    paragraphSize,
    colour,
    align,
    inverse = false,
    linkColour,
    listIcon,
    iconName,
    iconSize,
    iconColor,
    linkTarget
  } = _ref;
  return {
    renderMark: {
      [_richTextTypes.MARKS.BOLD]: children => {
        if (!children) return null;
        var childrenArr = _react.default.Children.toArray(children);
        if ((childrenArr === null || childrenArr === void 0 ? void 0 : childrenArr.length) === 1 && /*#__PURE__*/_react.default.isValidElement(childrenArr[0]) && childrenArr[0].type === 'br') return children;
        return /*#__PURE__*/_react.default.createElement(_RichTextBold.default, {
          align: align,
          colour: colour,
          inverse: inverse,
          size: paragraphSize
        }, children);
      }
    },
    renderNode: {
      [_richTextTypes.INLINES.HYPERLINK]: (node, children) => {
        var alternative = linkColour === 'alternative' ? true : false;
        return /*#__PURE__*/_react.default.createElement(_RichTextHyperlink.default, {
          inverse: inverse,
          alternative: alternative,
          target: linkTarget,
          href: node.data.uri
        }, children);
      },
      [_richTextTypes.BLOCKS.PARAGRAPH]: (node, children) => {
        // Convert empty paragraphs in jump of lines
        if (node.content.length === 1 && node.content[0].nodeType === 'text' && node.content[0].value === '') return /*#__PURE__*/_react.default.createElement("br", null);

        // TODO: figure out why UDS Paragraph does not renders with proper styles after HyperLinks. When using unit test and storybook catalog the Paragraph works well but in contentful and SB2 Paragraph breaks
        return /*#__PURE__*/_react.default.createElement(_RichTextParagraph.default, {
          testID: "rich-text-paragraph",
          size: paragraphSize,
          colour: colour,
          inverse: inverse,
          align: align
        }, children);
      },
      [_richTextTypes.BLOCKS.HEADING_1]: (_, children) => headingComponentWrapper('h1', children, inverse, align),
      [_richTextTypes.BLOCKS.HEADING_2]: (_, children) => headingComponentWrapper('h2', children, inverse, align),
      [_richTextTypes.BLOCKS.HEADING_3]: (_, children) => headingComponentWrapper('h3', children, inverse, align),
      [_richTextTypes.BLOCKS.HEADING_4]: (_, children) => headingComponentWrapper('h4', children, inverse, align),
      [_richTextTypes.BLOCKS.HEADING_5]: (_, children) => headingComponentWrapper('h5', children, inverse, align),
      [_richTextTypes.BLOCKS.HEADING_6]: (_, children) => headingComponentWrapper('h6', children, inverse, align),
      [_richTextTypes.BLOCKS.HR]: () => /*#__PURE__*/_react.default.createElement(_Divider.default, null),
      [_richTextTypes.BLOCKS.LIST_ITEM]: (_, children) => children,
      // TODO: @UDS all lists does not support INVERSE. waiting for UDS support
      [_richTextTypes.BLOCKS.UL_LIST]: (_, children) => {
        var size = _RichTextList.paragraphSizeToListSize[paragraphSize];
        return /*#__PURE__*/_react.default.createElement(_RichTextList.default, _extends({
          size: size,
          type: "ul"
        }, listIcon, {
          iconName: iconName,
          iconSize: iconSize,
          iconColor: iconColor,
          inverse: inverse
        }), children);
      },
      // TODO: @UDS ordered list does not support SIZE. waiting for UDS support
      [_richTextTypes.BLOCKS.OL_LIST]: (_, children) => {
        var size = _RichTextList.paragraphSizeToListSize[paragraphSize];
        return /*#__PURE__*/_react.default.createElement(_RichTextList.default, {
          size: size,
          type: "ol"
        }, children);
      }
    }
  };
};
exports.configOptions = configOptions;